import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  overflow: hidden;
  padding-top: 65px;
  @media (max-width: 992px){
    padding-top: 66px;
    @-moz-document url-prefix() {
    &{
        padding-top: 65px;
    }
}
  }
`;

export const ContentInner = styled.div`
  width: 100%;
  min-height: calc(100vh - 91px);
  padding: 20px;
  background-color: #ecf0f5;
`;



// WEBPACK FOOTER //
// ./src/components/content/index.js